module.exports = __webpack_public_path__ + "img/norm-4.f9976e1.png";